module.exports = {
  REGULAR: 'regular',
  ONCE: 'once',
};
